import ApiService from './ApiService'

// Admin scoped lists
export const apiListRoles = () => ApiService.get('/admin/list/roles')
export const apiListUsers = () => ApiService.get('/admin/list/users')
export const apiListCustomers = () => ApiService.get('/admin/list/customers')
export const apiListInspectors = () => ApiService.get('/admin/list/inspectors')
export const apiListProjects = () => ApiService.get('/admin/list/projects')
export const apiListTransformers = id => ApiService.get(`/admin/list/transformers${id ? `/${id}` : ''}`)
export const apiListTestTypes = id => ApiService.get(`/admin/list/test-types${id ? `/${id}` : ''}`)
export const apiListGlobals = () => ApiService.get('/admin/list/globals')
export const apiListCoolingTypes = () => ApiService.get('/admin/list/cooling-types')
export const apiListReferenceStandards = () => ApiService.get('/admin/list/reference-standards')
export const apiListWindingMaterials = () => ApiService.get('/admin/list/winding-materials')
export const apiListEquipments = () => ApiService.get('/admin/list/equipments', null, { loader: false })
export const apiListDiagrams = () => ApiService.get('/admin/list/diagrams', null, { loader: false })
export const apiListLabSurfaceAreas = () => ApiService.get('/admin/list/lab-surface-areas')
export const apiListTransformerTests = id => ApiService.get(`/admin/list/transformer-tests${id ? `/${id}` : ''}`)
export const apiListFeedbacks = () => ApiService.get('/admin/list/feedbacks')

// Admins
export const apiAdminsList = data => ApiService.get('/admin/admins', data)
export const apiAdminsView = id => ApiService.get(`/admin/admins/${id}`)
export const apiAdminsForm = (id, data) => ApiService.post(`/admin/admins${id ? `/${id}` : ''}`, data)
export const apiAdminsStatus = id => ApiService.post(`/admin/admins/${id}/status`)
export const apiAdminsVerified = id => ApiService.post(`/admin/admins/${id}/verified`)

// Login History
export const apiLoginHistoryList = data => ApiService.get('/admin/login-history', data)
export const apiSetting = data => ApiService.post('/admin/setting', data)

// Roles & Permissions
export const apiPermissions = () => ApiService.get('/admin/permission-datas')
export const apiRolesList = data => ApiService.get('/admin/roles', data)
export const apiRolesView = id => ApiService.get(`/admin/roles/${id}`)
export const apiRolesForm = (id, data) => ApiService.post(`/admin/roles${id ? `/${id}` : ''}`, data)
export const apiRolesStatus = id => ApiService.post(`/admin/roles/${id}/status`)

// Users
export const apiUsersList = data => ApiService.get('/admin/users', data)
export const apiUsersView = id => ApiService.get(`/admin/users/${id}`)
export const apiUsersForm = (id, data) => ApiService.post(`/admin/users${id ? `/${id}` : ''}`, data)
export const apiUsersStatus = id => ApiService.post(`/admin/users/${id}/status`)
export const apiUsersVerified = id => ApiService.post(`/admin/users/${id}/verified`)

// Customers
export const apiCustomersList = data => ApiService.get('/admin/customers', data)
export const apiCustomersView = id => ApiService.get(`/admin/customers/${id}`)
export const apiCustomersForm = (id, data) => ApiService.post(`/admin/customers${id ? `/${id}` : ''}`, data)
export const apiCustomersStatus = id => ApiService.post(`/admin/customers/${id}/status`)

// Inspectors
export const apiInspectorsList = data => ApiService.get('/admin/inspectors', data)
export const apiInspectorsView = id => ApiService.get(`/admin/inspectors/${id}`)
export const apiInspectorsForm = (id, data) => ApiService.post(`/admin/inspectors${id ? `/${id}` : ''}`, data)
export const apiInspectorsStatus = id => ApiService.post(`/admin/inspectors/${id}/status`)
export const apiInspectorsVerified = id => ApiService.post(`/admin/inspectors/${id}/verified`)

// Projects
export const apiProjectsList = data => ApiService.get('/admin/projects', data)
export const apiProjectsView = id => ApiService.get(`/admin/projects/${id}`)
export const apiProjectsForm = (id, data) => ApiService.post(`/admin/projects${id ? `/${id}` : ''}`, data)
export const apiProjectsStatus = id => ApiService.post(`/admin/projects/${id}/status`)

// Transformers
export const apiTransformersList = data => ApiService.get('/admin/transformers', data)
export const apiTransformersView = id => ApiService.get(`/admin/transformers/${id}`)
export const apiTransformersForm = (id, data) => ApiService.post(`/admin/transformers${id ? `/${id}` : ''}`, data)
export const apiTransformersStatus = id => ApiService.post(`/admin/transformers/${id}/status`)
export const apiTransformersLock = id => ApiService.post(`/admin/transformers/${id}/lock`)

// Test Types
export const apiTestTypesList = data => ApiService.get('/admin/test-types', data)
export const apiTestTypesView = id => ApiService.get(`/admin/test-types/${id}`)
export const apiTestTypesForm = (id, data) => ApiService.post(`/admin/test-types${id ? `/${id}` : ''}`, data)
export const apiTestTypesStatus = id => ApiService.post(`/admin/test-types/${id}/status`)

// Transformer Tests
export const apiTransformerTestsList = data => ApiService.get('/admin/transformer-tests', data)
export const apiTransformerTestsView = (id, data) => ApiService.get(`/admin/transformer-tests/${id}`, data)
export const apiTransformerTestsForm = (id, data) => ApiService.post(`/admin/transformer-tests${id ? `/${id}` : ''}`, data)
export const apiTransformerTestsDestroy = id => ApiService.destroy(`/admin/transformer-tests/${id}`)
export const apiTransformerTestsClone = id => ApiService.get(`/admin/transformer-tests/${id}/clone`)

// Tests
export const apiTestsList = (id, data) => ApiService.get(`/admin/transformer-tests${id ? `/${id}` : ''}/trans-tests`, data)
export const apiTestsView = id => ApiService.get(`/admin/trans-tests${id ? `/${id}` : ''}`)
export const apiTestsForm = (id, data) => ApiService.post(`/admin/trans-tests${id ? `/${id}` : ''}`, data)
export const apiTestsStatus = (id, data) =>
    ApiService.post(`/admin/trans-tests/${id}/${data.type === 0 ? 'status' : 'authorised'}`, data)

// Reports
export const apiTransReportsList = (id, data) => ApiService.get(`/admin/transformer-tests/${id}/reports`, data)
export const apiTransReportsForm = (id, data) => ApiService.post(`/admin/transformer-tests/${id}/reports`, data)
export const apiTransReportsDestroy = (id, data) => ApiService.get(`/admin/trans-reports/${id}/destroy`, data)

// Editable Reports
export const apiTransEditableReportsForm = (id, data) => ApiService.post(`/admin/transformer-tests/${id}/editable-reports`, data)
export const apiTransEditableReportsDestroy = (id, data) => ApiService.get(`/admin/trans-editable-reports/${id}/destroy`, data)

// Feedbacks
export const apiFeedbacksList = data => ApiService.get('/admin/feedbacks', data)
export const apiFeedbacksView = id => ApiService.get(`/admin/feedbacks/${id}`)
export const apiFeedbacksForm = (id, data) => ApiService.post(`/admin/feedbacks${id ? `/${id}` : ''}`, data)
export const apiFeedbacksPDF = id => ApiService.blob(`/admin/feedbacks/${id}/pdf`)
export const apiFeedbacksReportsCustomer = data => ApiService.get('/admin/feedbacks/reports/customer', data)
export const apiFeedbacksReportsMonthly = data => ApiService.get('/admin/feedbacks/reports/monthly', data)

// Cooling Types
export const apiCoolingTypesList = data => ApiService.get('/admin/cooling-types', data)
export const apiCoolingTypesView = id => ApiService.get(`/admin/cooling-types/${id}`)
export const apiCoolingTypesForm = (id, data) => ApiService.post(`/admin/cooling-types${id ? `/${id}` : ''}`, data)
export const apiCoolingTypesStatus = id => ApiService.post(`/admin/cooling-types/${id}/status`)

// Reference Standards
export const apiReferenceStandardsList = data => ApiService.get('/admin/reference-standards', data)
export const apiReferenceStandardsView = id => ApiService.get(`/admin/reference-standards/${id}`)
export const apiReferenceStandardsForm = (id, data) => ApiService.post(`/admin/reference-standards${id ? `/${id}` : ''}`, data)
export const apiReferenceStandardsStatus = id => ApiService.post(`/admin/reference-standards/${id}/status`)

// Winding Materials
export const apiWindingMaterialsList = data => ApiService.get('/admin/winding-materials', data)
export const apiWindingMaterialsView = id => ApiService.get(`/admin/winding-materials/${id}`)
export const apiWindingMaterialsForm = (id, data) => ApiService.post(`/admin/winding-materials${id ? `/${id}` : ''}`, data)
export const apiWindingMaterialsStatus = id => ApiService.post(`/admin/winding-materials/${id}/status`)

// Equipments
export const apiEquipmentsList = data => ApiService.get('/admin/equipments', data)
export const apiEquipmentsView = id => ApiService.get(`/admin/equipments/${id}`)
export const apiEquipmentsForm = (id, data) => ApiService.post(`/admin/equipments${id ? `/${id}` : ''}`, data)
export const apiEquipmentsStatus = id => ApiService.post(`/admin/equipments/${id}/status`)
export const apiEquipmentsExport = data => ApiService.get(`/admin/equipments-export`, data)

// Diagrams
export const apiDiagramsList = data => ApiService.get('/admin/diagrams', data)
export const apiDiagramsView = id => ApiService.get(`/admin/diagrams/${id}`)
export const apiDiagramsForm = (id, data) => ApiService.post(`/admin/diagrams${id ? `/${id}` : ''}`, data)
export const apiDiagramsStatus = id => ApiService.post(`/admin/diagrams/${id}/status`)

// Lab Surface Areas
export const apiLabSurfaceAreasList = data => ApiService.get('/admin/lab-surface-areas', data)
export const apiLabSurfaceAreasView = id => ApiService.get(`/admin/lab-surface-areas/${id}`)
export const apiLabSurfaceAreasForm = (id, data) => ApiService.post(`/admin/lab-surface-areas${id ? `/${id}` : ''}`, data)
export const apiLabSurfaceAreasStatus = id => ApiService.post(`/admin/lab-surface-areas/${id}/status`)
